import RatingPage from '@app-studio-web/ui/pages/RatingPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'changeReadiness'

const ANSWER_TEXTS = {
  '1': 'Not ready yet',
  '2': 'Somewhat ready',
  '3': 'Ready',
  '4': 'Very ready',
  '5': "Let's do this!",
}

export default function ChangeReadinessPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && Object.keys(ANSWER_TEXTS).includes(value) ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const rating = formData.get('rating') as string
    if (!rating) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How ready are you to transform your space?',
      answer_key: rating,
      answer: ANSWER_TEXTS[rating as keyof typeof ANSWER_TEXTS],
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  return (
    <RatingPage
      heading={t('pages.onboarding.v1.changeReadiness.heading')}
      leftText={t('pages.onboarding.v1.changeReadiness.options.1')}
      rightText={t('pages.onboarding.v1.changeReadiness.options.5')}
      onSubmit={handleSubmit}
      buttonBgColor="bg-white"
      headingSize="text-3xl"
      preselectedValue={preselectedValue}
    />
  )
}
